/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-body-clr[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{font-family:Montserrat!important}.input-for-modal[_ngcontent-%COMP%]{border:0;border-bottom:1px solid grey;height:calc(2.25rem + 2px)!important}.w-35[_ngcontent-%COMP%]{width:35%!important}\n/*# sourceMappingURL=my-health-care-modal.component.css.map*/"];
export { styles as styles };
